module.exports = __webpack_public_path__ + "static/media/3.457e934a.png";